module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAADmwAAA5sBPN8HMQAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAD9SURBVGiB7dm7CsJAFEXR0Q8UfJS+Os1fq4hWWliqcVsoKCETvBFyRnNXlyJwNiSEISE497+AEbADjsBAvacWYAxceTmoN5mVRADs1LtMIhFXYKje9jEgA26FiLNHNM0jUuERqfCIVFREjNTbPuYRqfjniItHNM0jUsHjjF12KJqqt5kA20JEro7o1ryvU7jOQwinL7c0L/JonYG+epsZMHyOL74nY/U2s7bETNTbzNoS81vflhA8Jl0VMTP1NrNITO4xam2Jmau3mUVibsBCvc2sImap3mbWlphMvc2M+M/QnzyclcWs1btqKYnZqzfV9nxnVsAG6Kn3OPfmDvGRR+4tfp4BAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/prev-arrow50.png
// module id = 478
// module chunks = 3